"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _TableHeaderRow = _interopRequireDefault(require("../TableHeaderRow/TableHeaderRow"));

var _elements = require("../../../styles/elements");

var _Table = require("../Table.styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TableContent = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function (_ref, inputRef) {
  var getTableProps = _ref.getTableProps,
      getTableBodyProps = _ref.getTableBodyProps,
      separate = _ref.separate,
      page = _ref.page,
      disabled = _ref.disabled,
      className = _ref.className,
      headerGroups = _ref.headerGroups,
      showHeader = _ref.showHeader,
      headerCellCls = _ref.headerCellCls,
      children = _ref.children;
  return (0, _jsxRuntime.jsxs)("table", _objectSpread(_objectSpread({}, getTableProps()), {}, {
    css: [_elements.table.styles.preflight, separate ? _Table.styles.separateTable : _Table.styles.base, page.length === 0 && _Table.styles.empty, disabled && _Table.styles.disabled, process.env.NODE_ENV === "production" ? "" : ";label:TableContent;"],
    className: (0, _clsx["default"])(page.length === 0 && 'empty', className),
    ref: inputRef,
    children: [(0, _jsxRuntime.jsx)("colgroup", {
      children: headerGroups.map(function (headerGroup) {
        return headerGroup.headers.map(function (column) {
          return (0, _jsxRuntime.jsx)("col", {
            style: {
              width: column.width,
              minWidth: column.width && !column.minWidth ? column.width : column.minWidth
            }
          }, column.id);
        });
      })
    }), showHeader && (0, _jsxRuntime.jsx)("thead", {
      children: headerGroups.map(function (headerGroup) {
        return (0, _jsxRuntime.jsx)(_TableHeaderRow["default"], _objectSpread(_objectSpread({}, headerGroup.getHeaderGroupProps()), {}, {
          headers: headerGroup.headers,
          separate: separate,
          headerCellCls: headerCellCls,
          disabled: disabled
        }));
      })
    }), (0, _jsxRuntime.jsx)("tbody", _objectSpread(_objectSpread({}, getTableBodyProps()), {}, {
      children: children
    }))]
  }));
}));
TableContent.displayName = 'TableContent';
TableContent.propTypes = {
  getTableProps: _propTypes.func.isRequired,
  getTableBodyProps: _propTypes.func.isRequired,
  page: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})).isRequired,
  headerGroups: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})).isRequired,
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]).isRequired,
  separate: _propTypes.bool,
  disabled: _propTypes.bool,
  className: _propTypes.string,
  showHeader: _propTypes.bool,
  headerCellCls: (0, _propTypes.shape)({
    styles: _propTypes.string
  })
};
TableContent.defaultProps = {
  separate: false,
  disabled: false,
  className: undefined,
  showHeader: true,
  headerCellCls: undefined
};
var _default = TableContent;
exports["default"] = _default;
//# sourceMappingURL=TableContent.js.map